import { render } from "./Orders.vue?vue&type=template&id=d44409a4"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Desktop/HMM-Projects/posvue-version-one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__